<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/logs:log-file.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          icon2="preview"
          @clickedButton2="showFile"
          @clickedButton1="showDetails"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="createdAt"
          sort-desc
          @cacheCommit="$store.commit('display/logs/logsSearchUpdate', {searchTerm:$event, searchType: 'file'})"
          :cachedSearch="$store.state.display.logs.fileLogsSearch"
          :customPanel="createPanel()"
        />

      </v-col>
    </v-row>

    <DetailInfoWindow
      ref="dialogShow" />

    <ShowLogFile
      ref="logFile" />
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import LogsService from '@/modules/display/services/logs-service';
import DetailInfoWindow from '@/modules/display/views/logs/log-file/DetailInfoWindow';
import TablePanel from '@/modules/display/views/logs/TablePanel';
import DataUtils from '@/modules/core/services/data-utils';
import Log from '@/modules/display/data/log';
import Utils from '@/modules/core/services/utils';
import Vue from 'vue';
import {i18n} from '@/plugins/i18next';
import ShowLogFile from "./log-file/ShowLogFile";

export default {
  name: "LogFileTable",
  components: {
    ShowLogFile,
    DataTablePaginated,
    DetailInfoWindow
  },
  data() {
    return {
      filterHours: true
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('display/logs:log-file.id'), value: 'id' },
        { text: this.$t('common:name'), value: 'elevatorId' },
        { text: this.$t('display/logs:log-file.message-time'), value: 'msgTime' },
        { text: this.$t('common:last-updated-on'), value: 'createdAt' },
        { text: this.$t('display/logs:log-file.file-type'), value: 'type' },
        { text: this.$t('display/logs:log-file.file-size'), value: 'fileSize' },
        { text: "", value: "controls", sortable: false }
      ]
    }
  },
  methods: {
    showDetails(item) {
      this.$refs.dialogShow.initialization(item);
    },
    showFile(item) {
      this.$refs.logFile.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;
      let filter = {filter24: this.filterHours};

      LogsService.readAllLogsPaginated(
        'logfile',
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        filter,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Log);
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:alive.alive-log-table')}));
        }
      );
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: {filterValue: this.filterHours}
      });
      instance.$on('customPanelValueUpdated', this.updateFilter);
      return instance;
    },
    updateFilter(value) {
      this.filterHours = value;
      this.$refs.table.callTableUpdate()
    }
  }
}
</script>
